import React from "react";
import "./Styles.css";
import Navbar from "../Sections/Navbar/Navbar";

const AboutUsPg = () => {
  return (
        <div className="aboutus-pg">
        <Navbar/>
        
        {/* Floating background decorations */}
        <div className="floating-decorations">
          {/* Floating Scriptures */}
          <div className="float-item float-text bob-1" style={{ top: "15%", left: "80%" }}>
            <p>"Christ in you, the hope of glory." <br /><span className="verse-ref">— Colossians 1:27</span></p>
          </div>
          <div className="float-item float-text bob-3" style={{ top: "45%", left: "5%" }}>
            <p>"The entrance of Thy words giveth light." <br /><span className="verse-ref">— Psalm 119:130</span></p>
          </div>
          <div className="float-item float-text bob-5" style={{ top: "70%", left: "82%" }}>
            <p>"Being in Christ Embassy is being more than just a church, it’s God’s vision."</p>
          </div>
          <div className="float-item float-text bob-7" style={{ top: "85%", left: "45%" }}>
            <p>"Catch the Spirit of the Word."</p>
          </div>
        </div>

        <section className=" container">
      <div className="aboutus-header">
        <h2>ABOUT US</h2>
        <p>
          Being in Christ Embassy is more than just a church service its a vision, God's vision. <br />
          You learn more than just the letters; rather you catch the Spirit of the word.
        </p>
      </div>

      <div className="aboutus-content">
        <div className="aboutus-left">
          <div className="aboutus-card">
            <div className="aboutus-item">
              <h4 className="highlight">VISION</h4>
              <p>
                Our vision is to take God’s divine presence to the people and nations of the earth 
                and to demonstrate the character of the spirit.
              </p>
            </div>
            <div className="aboutus-item">
                <h4 className="highlight">MISSION</h4>
              <p>
                Our Mission is to raise generations of men and women who will come into 
                their inheritance to fulfill God’s dream.
              </p>
              
            </div>
            <div className="aboutus-item">
              <h4 className="highlight">PURPOSE</h4>
              <p>
                Our Purpose is to bring men and women into their inheritance in Christ.
              </p>
            </div>
          </div>
        </div>

        <div className="aboutus-right">
          <img 
            src="https://thechroniclemagazine.com/wp-content/uploads/2025/02/Screenshot_20250207-121237_1-1.jpg" 
            alt="Pastor preaching" 
            fetchpriority="high"
            decoding="sync"
          />
        </div>
      </div>
    </section>
    </div>
  );
};

export default AboutUsPg;
